import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSourceDatabase, getConvertMySQLDBToMongoDB, getConvertMySQLToMongoDB } from "../../end-points/databaseConversion";
import {toast} from "react-toastify"

const initialState = {
  currentStep: 1,
  selectedSourceOption: undefined,
  selectedTargetOption: undefined,
  host: "",
  port: null,
  username: "",
  password: "",
  database: "",
  sourcePayload: null,
  targetPayload: null,
  apiResponseData: {}, // Actual API response data
  loading: false,
  error: null,
  mergedPayload: {},
  selectionType: null, // 'all' or 'selected'
};

export const sourceDatabase = createAsyncThunk(
  "dataConversion/sourceDatabase",
  async(payload, thunkAPI) => {
    try {
      const response = await getSourceDatabase(payload);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const convertMySQLDBToMongoDB = createAsyncThunk(
  "dataConversion/convertMySQLDBToMongoDB",
  async(payload, thunkAPI) => {
    try {
      const response = await getConvertMySQLDBToMongoDB(payload);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const convertMySQLToMongoDB = createAsyncThunk(
  "dataConversion/convertMySQLToMongoDB",
  async(payload, thunkAPI) => {
    try {
      const response = await getConvertMySQLToMongoDB(payload);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const databaseConversionSlice = createSlice({
  name: "databaseConversion",
  initialState,
  reducers: {
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
    setSelectedSourceOption: (state, action) => {
      state.selectedSourceOption = action.payload;
    },
    updateSelectedSourceOption: (state, action) => {
      const updatedState = state.selectedSourceOption.map(option => {
        if (!option || !option.inputName) {
          console.warn("Option or inputName is undefined:", option);
          return option;
        }
        let value = action.payload.name === option.inputName ? action.payload.value : option.value;
        if (option.inputName === "port" && typeof value === "string") {
          value = parseInt(value, 10);
        }
        option.value = value;
        if (action.payload.file && action.payload.name === option.inputName) {
          option.file = action.payload.file;
        }
        return option;
      });
      state.selectedSourceOption = updatedState;
    },
    setSourcePayload: (state, action) => {
      state.sourcePayload = action.payload;
    },
    setSelectedTargetOption: (state, action) => {
      state.selectedTargetOption = action.payload;
    },
    updateSelectedTargetOption: (state, action) => {
      const updatedState = state.selectedTargetOption.map(option => {
        if (!option || !option.inputName) {
          console.warn("Option or inputName is undefined:", option);
          return option;
        }
        let value = action.payload.name === option.inputName ? action.payload.value : option.value;
        if (option.inputName === "port" && typeof value === "string") {
          value = parseInt(value, 10);
        }
        option.value = value;
        if (action.payload.file && action.payload.name === option.inputName) {
          option.file = action.payload.file;
        }
        return option;
      });
      state.selectedTargetOption = updatedState;
    },
    setTargetPayload: (state, action) => {
      state.targetPayload = action.payload;
    },
    setMergedPayload: (state, action) => {
      state.mergedPayload = action.payload;
    },
    setSelectionType: (state, action) => {
      state.selectionType = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(sourceDatabase.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(sourceDatabase.fulfilled, (state, action) => {
      state.loading = false;
      state.apiResponseData = action.payload; // Store actual API response
      state.currentStep = 2;
    });
    builder.addCase(sourceDatabase.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
      toast.error("Please check the DB credentials");
    });

    builder.addCase(convertMySQLDBToMongoDB.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(convertMySQLDBToMongoDB.fulfilled, (state, action) => {
      state.loading = false;
      state.apiResponseData = action.payload; // Store actual API response
      // state.currentStep = 5;
      const data = action.payload.result;
      let flag = false;
      Object.entries(data).map(([key, value]) => {
        console.log("Key: ", key);
        if(!value.inserted_ids && value.includes("Error")){
          flag = true;
        }
      })
      if(flag){
        toast.error("Error occured during conversion");
      } else{
        toast.success("Database Conversion Successful");
      }
    });
    builder.addCase(convertMySQLDBToMongoDB.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(convertMySQLToMongoDB.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(convertMySQLToMongoDB.fulfilled, (state, action) => {
      state.loading = false;
      state.apiResponseData = action.payload; // Store actual API response
      // state.currentStep = 5;
      const data = action.payload.result;
      let flag = false;
      Object.entries(data).map(([key, value]) => {
        console.log("Key: ", key);
        if(!value.inserted_ids && value.includes("Error")){
          flag = true;
        }
      })
      if(flag){
        toast.error("Error occured during conversion");
      } else{
        toast.success("Database Conversion Successful");
      }
    });
    builder.addCase(convertMySQLToMongoDB.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});

// Action creators are generated for each case reducer function
export const {
  setSelectedSourceOption,
  setCurrentStep,
  updateSelectedSourceOption,
  setSourcePayload,
  setSelectedTargetOption,
  updateSelectedTargetOption,
  setTargetPayload,
  setMergedPayload,
  setSelectionType
} = databaseConversionSlice.actions;

export default databaseConversionSlice.reducer;